import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaProjectContainerModel } from "../../../../../../models/aggregates/sfa//project/SfaProjectContainer.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
    providedIn: 'root'
    })
    export class SfaProjectService extends BaseApiTemplateService<SfaProjectContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'project-hdrs';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'project-hdrs';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'project-hdrs';
        this.httpClient = http;
    }
    }